/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_DragInputs */

const cs_gallery_drag = /** @type {(inputs: Gallery_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přetáhněte pro změnu pořadí`)
};

const en_gallery_drag = /** @type {(inputs: Gallery_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag to reorder`)
};

/**
* | output |
* | --- |
* | "Drag to reorder" |
*
* @param {Gallery_DragInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_drag = /** @type {((inputs?: Gallery_DragInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_DragInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_drag(inputs)
	return cs_gallery_drag(inputs)
});